import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { graphql, useStaticQuery } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import { BgImage } from 'gbimage-bridge';

const Main = () => {
  const data = useStaticQuery(
    graphql`
    {
      main: file(relativePath: {eq: "images/main.jpg"}) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF], width: 1920)
        }
      }
    }
    `
  );
  return (
    <section id="main" className="main">
      <div className="main__frame">
        <BgImage className={"main__image"} image={getImage(data.main)}>
          <div className="main__imageWrapper">
            <Container className="main__imageContainer" fluid>
              <Row className="main__contentRow">
                <Col xl="8" className="ms-auto">
                  <div className="main__content">
                    <h2>
                      Эксперт в комплексном оснащении кухни и применении
                      нестандартных технологических решений
                    </h2>
                    <p>Мы с вами с&nbsp;1992 года</p>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </BgImage>
      </div>
    </section>
  );
};

export default Main;
